import { Link } from '@flos/react-ui';
import type { MultipleFieldValueInformation } from '../../config/flavourConfig';
import { useState } from 'react';

const TableRowValue = ({ value }: { value: MultipleFieldValueInformation }): React.JSX.Element => {
    const [showModal, setShowModal] = useState(false);
    return (
        <>
            <Link
                key={value.title}
                className="u-color-primary-2-base"
                onClick={() => {
                    setShowModal(true);
                }}
            >
                <ul className="u-Normalwrap">{value.title}</ul>
            </Link>
            {showModal && value.modalInformation && (
                <div className="u-text-left u-Normalwrap">
                    <value.modalInformation.modalType
                        showModal={showModal}
                        modalProps={value.modalInformation.modalProps}
                        closeModal={() => {
                            setShowModal(false);
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default TableRowValue;
